export const useMobileMenu = () => {
  const showMobileMenu = useState('showMobileMenu', () => <boolean>false)

  const setShowMobileMenu = (value: boolean) => {
    showMobileMenu.value = value
  }

  const toggleShowMobileMenu = () => {
    showMobileMenu.value = !showMobileMenu.value
  }

  return { showMobileMenu, setShowMobileMenu, toggleShowMobileMenu }
}
